<template>
  <main>
    <!-- Servicios -->
    <section id="servicios" class="servicios">
      <div class="container servicios__inner">
        <header class="servicios__head">
          <p class="eyebrow servicios__eyebrow">Servicios</p>
          <h2 class="servicios__title">Todo para estacionar sin vueltas.</h2>
        </header>

        <div class="svc-grid">
          <article
            v-for="s in servicios"
            :key="s.id"
            class="svc"
            :class="['svc--' + s.tono, 'svc--' + s.tamano]"
          >
            <div class="stage">
              <svg v-if="s.icono === 'llave'" width="68" height="68" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
                <circle cx="8" cy="12" r="4" />
                <circle cx="8" cy="12" r="1.2" />
                <path d="M12 12h9" />
                <path d="M18 12v3" />
                <path d="M21 12v2" />
              </svg>
              <img v-else :class="'img img--' + s.imgTipo" :src="s.img" alt="" />
            </div>
            <h3 class="svc__title">{{ s.titulo }}</h3>
            <p class="svc__text">{{ s.texto }}</p>
          </article>
        </div>
      </div>
    </section>

    <!-- Contacto -->
    <section id="contacto" class="contacto">
      <div class="container">
        <div class="contacto__card">
          <div class="contacto__text">
            <h2 class="contacto__title">¿Tarifas o disponibilidad?</h2>
            <p class="contacto__sub">Escribinos y te respondemos.</p>
          </div>

          <div class="contacto__action">
            <a class="btn btn--green contacto__btn" :href="consultaUrl" target="_blank" rel="noopener noreferrer">
              WhatsApp
            </a>
            <span class="contacto__phone">{{ telefono }}</span>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { NEGOCIO, whatsappUrl, WHATSAPP_PATH } from '../config';
import h24 from '../assets/h24-blanco.png';
import conductor from '../assets/conductor-verde.png';
import auto from '../assets/car-verde.png';
import moto from '../assets/moto-blanco.png';

export default {
  name: 'AppMain',
  data() {
    return {
      telefono: NEGOCIO.telefonoVisible,
      whatsappPath: WHATSAPP_PATH,
      servicios: [
        {
          id: 'vigilancia',
          titulo: 'Vigilancia 24 hs',
          texto: 'Cuidado permanente de tu vehículo, de día y de noche.',
          tono: 'dark',
          tamano: 'lg',
          img: h24,
          imgTipo: 'tall',
        },
        {
          id: 'valet',
          titulo: 'Valet parking',
          texto: 'Si preferís, estacionamos tu auto por vos.',
          tono: 'light',
          tamano: 'lg',
          img: conductor,
          imgTipo: 'tall',
        },
        {
          id: 'llave',
          titulo: 'Te llevás la llave',
          texto: 'Estacionás y la llave queda con vos.',
          tono: 'dark',
          tamano: 'sm',
          icono: 'llave',
        },
        {
          id: 'espacios',
          titulo: 'Espacios amplios',
          texto: 'Para autos, camionetas y traffics.',
          tono: 'light',
          tamano: 'sm',
          img: auto,
          imgTipo: 'car',
        },
        {
          id: 'motos',
          titulo: 'Sector para motos',
          texto: 'Lugar exclusivo para motocicletas.',
          tono: 'dark',
          tamano: 'sm',
          img: moto,
          imgTipo: 'moto',
        },
      ],
    };
  },
  computed: {
    consultaUrl() {
      return whatsappUrl('Hola, quería consultar tarifas y disponibilidad.');
    },
  },
};
</script>

<style scoped>
/* ---------- Servicios ---------- */
.servicios {
  background: var(--green);
  scroll-margin-top: 96px;
}

.servicios__inner {
  display: flex;
  flex-direction: column;
  gap: 44px;
  padding-top: 80px;
  padding-bottom: 80px;
}

.servicios__head {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  text-align: center;
}

.servicios__eyebrow {
  color: var(--mint);
}

.servicios__title {
  margin: 0;
  font-family: var(--display);
  font-weight: 800;
  font-size: clamp(26px, 4.2vw, 48px);
  line-height: 1.08;
  letter-spacing: -0.02em;
  color: #ffffff;
  text-wrap: balance;
}

.svc-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 18px;
}

.svc {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 20px;
  padding: 36px 24px 34px;
  border-radius: 32px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.svc:hover {
  transform: translateY(-6px);
  box-shadow: 0 22px 44px rgba(0, 20, 10, 0.35);
}

.svc--lg {
  grid-column: span 3;
}

.svc--sm {
  grid-column: span 2;
}

.svc--dark {
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.26);
  color: #ffffff;
}

.svc--light {
  background: #ffffff;
  border: 1px solid #ffffff;
  color: var(--green);
}

.stage {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.svc--lg .stage {
  width: 180px;
  height: 180px;
}

.svc--sm .stage {
  width: 136px;
  height: 136px;
}

.svc--dark .stage {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.24);
}

.svc--light .stage {
  background: #e8f3ec;
  border: 1px solid #cfe5d8;
}

.img {
  display: block;
  height: auto;
}

.img--tall {
  height: 112px;
  width: auto;
}

.img--car {
  width: 96px;
}

.img--moto {
  width: 84px;
}

.svc__title {
  margin: 0;
  font-family: var(--display);
  font-weight: 800;
  font-size: 19px;
  line-height: 1.2;
  text-wrap: balance;
}

.svc__text {
  margin: 0;
  max-width: 300px;
  font-size: 16px;
  line-height: 1.5;
}

.svc--dark .svc__text {
  color: #cfe6d6;
}

.svc--light .svc__text {
  color: var(--muted);
}

@media (max-width: 900px) {
  .svc--lg,
  .svc--sm {
    grid-column: span 3;
  }

  .svc--sm:last-child {
    grid-column: span 6;
  }
}

@media (max-width: 560px) {
  .servicios__inner {
    gap: 32px;
    padding-top: 56px;
    padding-bottom: 56px;
  }

  .svc--lg,
  .svc--sm,
  .svc--sm:last-child {
    grid-column: span 6;
  }

  /* Tarjetas más compactas para que no haya tanto scroll en el celular */
  .svc {
    gap: 14px;
    padding: 24px 20px;
  }

  .svc--lg .stage,
  .svc--sm .stage {
    width: 112px;
    height: 112px;
  }

  .img--tall {
    height: 78px;
  }

  .img--car {
    width: 76px;
  }

  .img--moto {
    width: 68px;
  }

  .stage svg {
    width: 50px;
    height: 50px;
  }
}

/* ---------- Contacto ---------- */
.contacto {
  background: #ffffff;
  scroll-margin-top: 96px;
  padding: 64px 0;
}

.contacto__card {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  padding: clamp(24px, 5vw, 52px);
  border-radius: 32px;
  background: var(--tint);
  border: 1.5px solid #bfddcb;
  color: var(--green);
}

.contacto__text {
  flex: 1 1 340px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.contacto__title {
  margin: 0;
  font-family: var(--display);
  font-weight: 800;
  font-size: clamp(22px, 4vw, 44px);
  line-height: 1.1;
  letter-spacing: -0.02em;
  overflow-wrap: anywhere;
  text-wrap: balance;
}

.contacto__sub {
  margin: 0;
  font-size: 17px;
  font-weight: 500;
  color: #2f5440;
}

.contacto__action {
  flex: 0 1 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.contacto__btn {
  min-width: 240px;
  padding: 20px 30px;
  font-size: 18px;
  text-align: center;
}

.contacto__phone {
  font-family: var(--mono);
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.04em;
}

@media (max-width: 560px) {
  .contacto {
    padding: 40px 0;
  }

  /* En columna (no en fila que se parte) para que el botón nunca se salga de la tarjeta */
  .contacto__card {
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: stretch;
    gap: 22px;
    padding: 28px 20px;
  }

  .contacto__text {
    flex: none;
    width: 100%;
    gap: 10px;
  }

  .contacto__title {
    font-size: 21px;
  }

  .contacto__sub {
    font-size: 16px;
  }

  .contacto__action {
    flex: none;
    width: 100%;
    min-width: 0;
    align-items: stretch;
  }

  .contacto__btn {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding: 18px 14px;
    font-size: 17px;
    white-space: nowrap;
  }

  .contacto__phone {
    text-align: center;
  }
}
</style>
